import { CSSProperties } from "react";

import { createCustomTheme, IgCustomTheme } from "@intelligems/ig-theme";
import {
  CustomShadows,
  CustomTypeText,
  IgBorderColorsType,
  IgCoreBackgroundColorsType,
  IgIconColorType,
  IgPrimitivesType,
} from "@intelligems/ig-types";

declare module "@mui/material/styles" {
  interface Theme {
    igShadows: CustomShadows;
    igBorders: IgBorderColorsType;
    igIconColors: IgIconColorType;
    igBackgroundColors: IgCoreBackgroundColorsType;
    igPrimitives: IgPrimitivesType;

    [key: string]: any;
  }

  interface ThemeOptions {
    igShadows?: Partial<CustomShadows>;
    igBorders?: IgBorderColorsType;
    igIconColors?: IgIconColorType;
    igBackgroundColors?: IgCoreBackgroundColorsType;
    igPrimitives?: IgPrimitivesType;

    [key: string]: any;
  }

  interface TypographyVariants {
    body3: CSSProperties;
    display: CSSProperties;
    code: CSSProperties;
  }

  interface TypographyVariantsOptions {
    body3?: CSSProperties;
    display?: CSSProperties;
    code?: CSSProperties;
  }

  interface Palette {
    disabled: Palette["primary"];
    accent: Palette["primary"];
    link: Palette["primary"];
  }

  interface PaletteOptions {
    disabled?: Palette["primary"];
    accent?: Palette["primary"];
    link?: Palette["primary"];
  }
}

declare module "@mui/material/styles/createPalette" {
  interface Palette {
    disabled: Palette["primary"];
    accent: Palette["primary"];
    link: Palette["primary"];
  }

  interface PaletteOptions {
    disabled?: Palette["primary"];
    accent?: Palette["primary"];
    link?: Palette["primary"];
  }

  interface TypeText extends CustomTypeText {}
}

declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    body3: true;
    display: true;
    code: true;
  }
}

declare module "@mui/material/SvgIcon" {
  interface SvgIconPropsColorOverrides {
    dark: true;
    darkHover: true;
    light: true;
    lightHover: true;
    accent: true;
    accentHover: true;
  }
}

declare module "@mui/material/Button" {
  interface ButtonPropsColorOverrides {
    accent: true;
    link: true;
  }

  interface ButtonPropsSizeOverrides {
    extraSmall: true;
  }
}

declare module "@mui/material/Chip" {
  interface ChipPropsColorOverrides {
    accent: true;
  }
}

declare module "@mui/material/Badge" {
  interface BadgePropsColorOverrides {
    accent: true;
  }
}

declare module "@mui/material/Fab" {
  interface FabPropsColorOverrides {
    accent: true;
    accentDisabled: true;
  }
}

export const theme: IgCustomTheme = createCustomTheme();

export const Theme = typeof theme;
